import {Type, Static} from "@sinclair/typebox";
interface DefiniceVykazu
{
  kod : string;
  nazev : string;
  platnaOd : string;
  platnaDo : string;
  pouzivaReferencniVysledekVypoctu : boolean;
  popis : string;
  kodUj : string;
  urceniDefiniceVykazu? : Array<UrceniDefiniceVykazuDto>;
  definicePolozkyVykazu? : Array<DefinicePolozkyVykazu>;
  opakovaneRadky? : Array<OpakovaneRadky>;
  displayValue?:string;
  typVypoctuHlavniKnihy?: number;
  typVypoctuHlavniKnihyDisplayValue?: string;
  }
export interface DefiniceVykazuDto extends DefiniceVykazu
{
  id : number;
  totalCount? : number;
}
export interface  CreateDefiniceVykazu
{
  kod?: string,
  nazev?: string,
  platnaOd?: string;
  platnaDo?: string;
  pouzivaReferencniVysledekVypoctu?: boolean;
  popis?: string;
  kodUj?: string;
  urceniDefiniceVykazu? : Array<UrceniDefiniceVykazuDto>;
  definicePolozkyVykazu? : Array<DefinicePolozkyVykazu>;
  opakovaneRadky? : Array<OpakovaneRadky>;
  typVypoctuHlavniKnihy? : TypVypoctuHlavniKnihy;
}

export interface EditDefiniceVykazu extends DefiniceVykazu
{
  id?: number;
}

//HELPING INTERFACES
export interface UrceniDefiniceVykazuDto
{
  id? : number;
  kodPravniFormy? : string;
  idDefiniceVykazu? : number;
}

export interface DefinicePolozkyVykazu
{
  id?: number;
  poradiRadku: number;
  poradiSloupce: number;
  kodRadku: string;
  kodSloupce: string;
  vzorec: string;
  levelVypoctu: number;
  popis: string;
  zpusobZiskaniHodnoty: number;
  typHodnotyVysledku: number;
  manualniHodnotaSeVyplnuje: boolean;

}
export interface OpakovaneRadky
{
  idDefiniceVykazu? : number;
  kodRadku : string;
}
export interface IndexParam
{
  index: number;
  name: string;
}
export class Indexes
{
  poradiRadku: IndexParam = {name: 'PoradiRadku', index: 0};
  poradiSloupce: IndexParam = {name: 'PoradiSloupce', index: 0};
  kodRadku: IndexParam = {name: 'KodRadku', index: 0};
  kodSloupce: IndexParam = {name: 'KodSloupce', index: 0};
  popisNazevSloupce: IndexParam = {name: 'Popis-NazevSloupce', index: 0};
  popisNazev: IndexParam = {name: 'Popis-Nazev', index: 0};
  popisPodrozvahovyUcet: IndexParam = {name: 'Popis-PodrozvahovyUcet', index: 0};
  popisSyntetickyUcet: IndexParam = {name: 'Popis-SyntetickyUcet', index: 0};
  levelVypoctu: IndexParam = {name: 'LevelVypoctu', index: 0};
  zpusobZiskaniHodnoty: IndexParam = {name: 'ZpusobZiskaniHodnoty', index: 0};
  vzorec: IndexParam = {name: 'Vzorec', index: 0};
  typHodnotyVysledku: IndexParam = {name: 'TypHodnotyVysledku', index: 0};
  manualniHodnota: IndexParam = {name: 'ManualniHodnotaSeVyplnuje', index: 0};
}

export const profileSchema = Type.Object
({
  kod: Type.String(),
  nazev: Type.String(),
  platnaOd: Type.String(),
  platnaDo: Type.String(),
  pouzivaReferencniVysledekVypoctu:Type.Boolean(),
  popis: Type.String(),
  kodUj:Type.String(),
});

export type ProfileSchemaType = Static<typeof profileSchema>;

export enum TypHodnoty
{
  Bool,
  Curr,
  Date,
  Int,
  String
}

export enum TypVypoctuHlavniKnihy
{
  Su,
  SuHc,
  SuAu,
  SuAuHc
}
